export type TaxIdType = { code: string; name: string };

// Curated short list of Stripe tax ID types. Full list:
// https://docs.stripe.com/api/customer_tax_ids/object#tax_id_object-type
export const TAX_ID_TYPES: TaxIdType[] = [
  { code: "eu_vat", name: "EU VAT" },
  { code: "gb_vat", name: "UK VAT" },
  { code: "ch_vat", name: "Swiss VAT" },
  { code: "no_vat", name: "Norway VAT" },
  { code: "us_ein", name: "US EIN" },
  { code: "ca_bn", name: "Canada BN" },
  { code: "au_abn", name: "Australia ABN" },
  { code: "nz_gst", name: "New Zealand GST" },
  { code: "jp_cn", name: "Japan Corporate Number" },
  { code: "sg_uen", name: "Singapore UEN" },
];
